import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { OrganisationPreferenceRemoteInterface } from '@careapp/angular-sdk';

import { FormCoreComponent } from '../form-core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'organisation-preferences-form',
  templateUrl: './organisation-preferences-form.component.html',
  styleUrls: ['./organisation-preferences-form.component.scss']
})
export class OrganisationPreferencesFormComponent extends FormCoreComponent<
OrganisationPreferenceRemoteInterface
> {
  @Input()
  set preferences(value: OrganisationPreferenceRemoteInterface) {
    if (value) {
      this.form.patchValue(value, { emitEvent: false, onlySelf: true });
      this.updateShareCheckIns(value);
    }
  }

  shareCheckIns = new FormControl(false);
  subs: Subscription[] = [];

  constructor() {
    super();
    this.form = new FormGroup({
      severeConcernWarning: new FormControl(false, Validators.required),
      severeConcernMessage: new FormControl(false),
      autoShareLow: new FormControl(false, Validators.required),
      autoShareMid: new FormControl(false, Validators.required),
      autoShareHigh: new FormControl(false, Validators.required),
      autoShareSevere: new FormControl(false, Validators.required),
      minCheckInShareScore: new FormControl(-1, Validators.required),
      maxCheckInShareScore: new FormControl(-1, Validators.required),
    });
    this.subs.push(this.shareCheckIns.valueChanges.subscribe(share => this.updateMinMaxCheckIns()));
    this.subs.push(this.form.valueChanges.subscribe(changes => this.updateShareCheckIns(this.form.value)));
  }

  updateMinMaxCheckIns() {
    const opts = { emitEvent: false, onlySelf: true };
    const share = this.shareCheckIns.value;
    if (share) {
      this.form.patchValue({
        minCheckInShareScore: 0,
        maxCheckInShareScore: 3
      }, opts)
    } else {
      this.form.patchValue({
        minCheckInShareScore: -1,
        maxCheckInShareScore: -1
      }, opts)
    }
  }

  updateShareCheckIns(formValue) {
    const opts = { emitEvent: false, onlySelf: true };
    let values = { minCheckInShareScore: formValue.minCheckInShareScore, maxCheckInShareScore: formValue.maxCheckInShareScore }
    // Prevent values from getting out of whack (min > max or max > min)
    if (values.minCheckInShareScore > values.maxCheckInShareScore) {
      values.minCheckInShareScore = values.maxCheckInShareScore;
    }
    if (values.maxCheckInShareScore < values.minCheckInShareScore) {
      values.maxCheckInShareScore = values.minCheckInShareScore;
    }
    this.form.patchValue(values, opts);

    // Update the toggle slider (if server returns -1 for either value)
    if (formValue.maxCheckInShareScore === -1) {
      this.shareCheckIns.patchValue(false, opts);
    } else {
      this.shareCheckIns.patchValue(true, opts);
    }
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
